<script>
import MemberIndexList from '@/components/org/MemberIndexList'
import BottomToolbar from '@/components/org/BottomToolbar'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-referee-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'member-index-list': MemberIndexList,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            refereeList: null,
            organizationId: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onRefereeItemClick(item) {
            console.log('onRefereeItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailReferee',
                    params: {
                        id: item.id
                    }
                }
            })
        },
        onRefereeItemCreate() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateReferee',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
        onRefereeInvite(item) {
            console.log('onRefereeInvite', item)
            this.$emit('custom-event', {
                type: 'invite-referee',
                data: {
                    id: item.id,
                }
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateReferee',
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
    },
}
</script>
<template>
    <div class="referee-list">
        <member-index-list
            :memberList="refereeList"
            :memberEmptyHint="locale['referee-empty-hint']"
            :memberInviteLabel="locale['invite-label']"
            @create-member="onRefereeItemCreate"
            @click-member="onRefereeItemClick"
            @invite-member="onRefereeInvite"
        />
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['create']"
            @click-main-button="onCreateBtnClick"
        />
    </div>
</template>